import { Image } from '@bfe/moly';
import { publicAssetsPath } from '@web3/base-utils';
import { SingleDrawLotteryStatus } from '@/services/lottery';
import clsx from 'clsx';

type RewardGridProps = {
  rewards: SingleDrawLotteryStatus[];
};

export const RewardGrid = ({ rewards }: RewardGridProps) => {
  const totalItems = rewards.length;
  const firstRowItems = Math.min(totalItems, 5);
  const secondRowItems = totalItems > 5 ? totalItems - 5 : 0;

  return (
    <div className="flex flex-col gap-2">
      {/* 第一行 */}
      <div className="flex gap-2">
        {rewards.slice(0, firstRowItems).map((reward, index) => (
          <RewardCard key={`first-${index}`} reward={reward} />
        ))}
      </div>

      {/* 如果有第二行 */}
      {secondRowItems > 0 && (
        <div
          className={clsx(
            'flex gap-2',
            // 根据第二行数量设置不同的 margin
            {
              'justify-center': secondRowItems < 5,
              'justify-start': secondRowItems === 5,
            }
          )}
        >
          {rewards.slice(5, totalItems).map((reward, index) => (
            <RewardCard key={`second-${index}`} reward={reward} />
          ))}
        </div>
      )}
    </div>
  );
};

type RewardCardProps = {
  reward: SingleDrawLotteryStatus;
};

const RewardCard = ({ reward }: RewardCardProps) => {
  const { tokenIcon, amount, rewardToken } = reward;

  return (
    <div className="relative w-[76px] h-[112px] flex items-center justify-center">
      <Image
        className="w-[76px] h-[112px]"
        src={publicAssetsPath('/png/home/card-background.png')}
        alt="halo"
      />
      <Image className="absolute w-8 h-8" src={tokenIcon} alt={rewardToken} />
      <div
        className="absolute bottom-3 left-1/2 -translate-x-1/2"
        style={{
          background: 'linear-gradient(180deg, #FFF 38.89%, #6A2EAF 113.89%)',
          backgroundClip: 'text',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          display: 'inline-block',
        }}
      >
        {amount}
      </div>
    </div>
  );
};
